export default __webpack_public_path__ + "static/media/Red0002.44f499c7.png";